import React from 'react';
import PageHeader from './PageHeader';
import PageTitle from './PageTitle';
import ITPDiagram from "./ITPDiagram";

const ProgressOverview = () => {
	return (
		<div className='Overview'>
			<PageHeader title={'Overview'} />
			<div className={'container progress-brief my-32'}>
				<PageTitle title={'Introduction'} />
				<div className="flex">
					<div className={'mr-4'}>
						<p>
							This Progress Report is a simple tool to help you reflect on how you've grown since taking the initial assessment.
							It gives you a side-by-side look at your initial and most recent scores, offering an idea of how your behaviors have evolved over time.
						</p>
						<p>
							But remember, this isn’t just about numbers.
							The real value of this report lies in the insight it provides and the conversations it sparks.
							It’s not about chasing perfect scores.
							It’s about understanding where you’ve improved, where growth is still needed, and how you can keep becoming the kind of team player every team wants and needs.

						</p>
						<p>
							As you review your results, focus especially on the virtue that ranked lowest in your initial assessment.
							Be honest about the progress you’ve made, and where you’re still falling short.
							Growth doesn’t come from big, dramatic changes. It comes from small, consistent steps taken every day.
						</p>
						<p>
							Use this report as a guide. Keep it close. Revisit it often. And remember, being an ideal team player isn’t about arriving at perfection.
							It’s about committing to the journey.
						</p>
					</div>
					<div className="flex justify-center mt-15 h-auto">
						<ITPDiagram
							width="350"
							height="350"
							fillHumble="#80929d"
							fillHungry="#263e4b"
							fillSmart="#1c2130"
							strokeColor="#1F2937"
							strokeWidth={'1px'}
							id="overview-diagram"
							titleTextSize={'22px'}
							subtitleTextSize={'19px'}
							smartYPaddingOffset={20}
							hungryYPaddingOffset={35}
							humbleYPaddingOffset={35}
							smartRotPaddingOffset={0}
							hungryRotPaddingOffset={58}
							humbleRotPaddingOffset={58}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProgressOverview;
